(() => {
  'use strict';
  if (!window.customElements || customElements.get('ss-size-chart')) return;

  class SSSizeChart extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const details = this.querySelector('details');
      const trigger = details && details.querySelector('summary');
      const panel = details && details.querySelector('.ss-size-chart__panel');
      if (!trigger || !panel || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
      this.initialized = true;
      const dialog = document.createElement('dialog');
      dialog.id = this.dataset.dialogId;
      dialog.className = 'ss-size-chart__dialog';
      dialog.setAttribute('aria-labelledby', this.dataset.titleId);
      dialog.appendChild(panel);
      this.appendChild(dialog);
      this.dialog = dialog;
      details.open = false;
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-controls', dialog.id);
      trigger.setAttribute('aria-expanded', 'false');
      const closeButton = dialog.querySelector('[data-ss-chart-close]');
      closeButton.hidden = false;
      closeButton.autofocus = true;
      // Programmatic dialog focus may match :focus-visible on touch browsers.
      // Track real input instead of hiding keyboard focus globally.
      this.addEventListener('pointerdown', () => {
        this.setAttribute('data-ss-pointer', '');
      }, { passive: true });
      this.addEventListener('keydown', (event) => {
        if (!['Shift', 'Control', 'Alt', 'Meta'].includes(event.key)) {
          this.removeAttribute('data-ss-pointer');
        }
      });
      const title = dialog.querySelector('.ss-size-chart__title');
      const fitTitle = () => {
        if (!dialog.open || !title) return;
        title.style.removeProperty('font-size');
        title.style.removeProperty('white-space');
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        title.style.setProperty('white-space', 'nowrap');
        let size = 12;
        title.style.setProperty('font-size', size + 'px', 'important');
        while (title.scrollWidth > title.clientWidth + 1 && size > 10) {
          size = Math.max(10, size - 0.25);
          title.style.setProperty('font-size', size + 'px', 'important');
        }
        // Preserve full text and readability for unusually long product names.
        if (title.scrollWidth > title.clientWidth + 1) title.style.removeProperty('white-space');
      };
      if ('ResizeObserver' in window) this.titleObserver = new ResizeObserver(fitTitle);
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (dialog.open) return;
        this.returnFocus = document.activeElement;
        if (event.detail > 0) this.setAttribute('data-ss-pointer', '');
        dialog.showModal();
        fitTitle();
        if (this.titleObserver) this.titleObserver.observe(dialog);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitle);
        trigger.setAttribute('aria-expanded', 'true');
        closeButton.focus({ preventScroll: true });
      });
      closeButton.addEventListener('click', () => dialog.close());
      let pointerStartedOutside = false;
      const outside = (event) => {
        const rect = dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      };
      dialog.addEventListener('pointerdown', (event) => {
        pointerStartedOutside = event.target === dialog && outside(event);
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog && pointerStartedOutside && outside(event)) dialog.close();
        pointerStartedOutside = false;
      });
      dialog.addEventListener('close', () => {
        if (this.titleObserver) this.titleObserver.disconnect();
        trigger.setAttribute('aria-expanded', 'false');
        if (this.returnFocus && this.returnFocus.isConnected) this.returnFocus.focus({ preventScroll: true });
      });
    }

    disconnectedCallback() {
      if (this.titleObserver) this.titleObserver.disconnect();
      if (this.dialog && this.dialog.open) this.dialog.close();
    }
  }

  customElements.define('ss-size-chart', SSSizeChart);
})();